import { Button } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const Panel = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: minmax(100px, 200px) 1fr minmax(100px, 200px);
    justify-content: center;
    align-items: center;
    gap: ${spacing.sm};
  `}
`;

export const PanelButtons = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${spacing.p3};
  `}
`;

export const PanelButton = styled(Button)`
  ${({ disabled, theme: { borderRadius, color } }) => css`
    background-color: ${color.white};
    cursor: pointer;
    position: relative;
    z-index: 1;
    span {
      position: relative;
      z-index: 1;
    }
    width: 44px;
    height: 44px;
    border-radius: ${borderRadius.lg};
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    ${!disabled &&
    css`
      &:hover {
        filter: brightness(90%);
      }
    `}
    ${disabled &&
    css`
      && {
        background-color: ${color.lightGrey};
        pointer-events: none;
      }
    `}
  `}
`;

export const HangUpButton = styled(PanelButton)`
  ${({ theme: { color } }) => css`
    background: ${color.red};
  `}
`;

export const OnlineIndicator = styled.div`
  ${({ theme: { spacing, borderRadius, color } }) => css`
    background: #a3bcd826; // blue20 with alpha
    color: ${color.blue30};
    border: 1px solid #d6e1ee1a; // blue30 with alpha
    border-radius: ${borderRadius.p1};
    padding: ${spacing.xs} ${spacing.sm};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${spacing.p2};
  `}
`;

export const OnlineIndicatorDot = styled.div`
  ${({ $online, theme: { color, borderRadius } }) => css`
    border-radius: ${borderRadius.lg};
    width: 8px;
    height: 8px;
    background-color: ${$online ? color.turquoise : color.red};
  `}
`;


export const StyledPulseCircle = styled.div`
  position: absolute;
  z-index: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;
  height: 100%;
  opacity: 0.5;
  transition: all 0.1s ease-out;
`;
